import React, { ReactNode } from "react"
import Components from "../index"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { blokType } from "../../types"
import {
    StyledSection,
    StyledSectionBackgroundImage,
    StyledSectionContainer,
    StyledSectionHeader,
    StyledSectionIntro,
    StyledSectionLabel,
    StyledSectionHeading,
    StyledSectionDescription,
    StyledSectionHeaderContent,
    StyledSectionHighlight,
    StyledSectionBody,
} from "./partials"

export interface SectionProps {
    id: string
    label: string
    title: string
    description: string
    header_content: blokType[]
    highlight: blokType[]
    body_offset: string
    body: blokType[]
    background_color: string
    background_image: blokType[]
    background_image_repeat: boolean
    custom_id: string
    microdata: boolean
}

export const SectionCmp: React.FC<SectionProps> = ({
    id,
    label,
    title,
    description,
    header_content,
    highlight,
    body_offset,
    body,
    background_color,
    background_image,
    background_image_repeat,
    custom_id,
    microdata,
}) => {
    return(
    <StyledSection
    data-name="section"
        itemScope
         body_offset={body_offset}
        itemType={microdata ? "https://schema.org/FAQPage" : undefined}
        id={custom_id ? custom_id : id}
        background_color={background_color}
        background_image={
            background_image && background_image.length > 0 ? true : false
        }
    >
        {background_image && background_image.length > 0 && (
            <StyledSectionBackgroundImage
                background_image={background_image[0].media.filename}
                background_image_repeat={background_image_repeat}
            />
        )}
        <StyledSectionContainer>
            {(label || title || description || highlight.length > 0) && (
                <StyledSectionHeader>
                    <StyledSectionIntro>
                        {label && (
                            <StyledSectionLabel background_color={background_color}>
                                {label}
                            </StyledSectionLabel>
                        )}
                        {title && (
                            <StyledSectionHeading background_color={background_color}>
                                {title}
                            </StyledSectionHeading>
                        )}
                        {description && (
                            <StyledSectionDescription background_color={background_color}>
                                {
                                    unified()
                                        .use(remarkParse)
                                        .use(remarkRehype)
                                        .use(rehypeReact as any, {
                                          createElement: React.createElement,
                                          components: remarkReactComponents,
                                          Fragment: React.Fragment
                                        })
                                        .processSync(description.replace(/\n/g, "  \n"))
                                        .result as ReactNode
                                }
                            </StyledSectionDescription>
                        )}
                        {header_content && (
                            <StyledSectionHeaderContent>
                                {header_content.map((content: blokType) =>
                                    React.createElement(Components(content.component), {
                                        key: content._uid,
                                        blok: content,
                                    })
                                )}
                            </StyledSectionHeaderContent>
                        )}
                    </StyledSectionIntro>
                    {highlight.length > 0 && (
                        <StyledSectionHighlight>
                            {highlight.map((content: blokType) =>
                                React.createElement(Components(content.component), {
                                    key: content._uid,
                                    blok: content,
                                })
                            )}
                        </StyledSectionHighlight>
                    )}
                </StyledSectionHeader>
            )}
            {body.length > 0 && (
                <StyledSectionBody body_offset={body_offset}>
                    {body.map((content: blokType) =>
                        React.createElement(Components(content.component), {
                            key: content._uid,
                            blok: content,
                            microdata: microdata,
                        })
                    )}
                </StyledSectionBody>
            )}
        </StyledSectionContainer>
    </StyledSection>
)}
